/**
 * Ejecuta la substración del minuendo por el sustraendo.
 * Devuele el resto calculado
 *
 * @param {float} minuend: el total
 * @param {float} subtrahend: el numero a restar
 *
 * @return {float} el resto
 */

import { add } from './add';

export function sub(minuend, subtrahend) {
  return add(minuend, -1 * subtrahend);
}
